import { Expander, ExpanderLayout, ExpanderSize } from "@amzn/stencil-react-components/expander";
import { Row, Spacer } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { StencilThemeSpaces } from "@amzn/stencil-react-theme-default";
import { trackCustomEvent } from "@amzn/uxm-stencil-react-components/lib/src/uxm/custom-event";
import { config } from "config";
import React from "react";

interface ExpanderProps {
  title: string;
  content: string;
  layout?: ExpanderLayout;
  contentSpacing?: number | keyof StencilThemeSpaces;
}

const ExpanderQuestion = (props: ExpanderProps): React.JSX.Element => {
  return (
    <Expander
      data-test-id="expander-question"
      titleText={props.title}
      size={ExpanderSize.Small}
      layout={props.layout}
      contentSpacing={props.contentSpacing}
      onToggle={(isExpanded: boolean) => {
        const trackerId = config.analytics.uxmAppId;

        const expanderPayload = {
          isExpanded,
          titleText: props.title,
        };

        trackCustomEvent(expanderPayload, "expander-question", trackerId);
      }}
    >
      <Row>
        <Spacer width={40} />
        <Text style={{ whiteSpace: "pre-wrap" }} fontSize={"T100"} fontWeight={400} color="neutral90">
          {props.content}
        </Text>
      </Row>
    </Expander>
  );
};

export default ExpanderQuestion;
